
const menuItems: MenuItemData[] = [
	{
		label: "home",
		link: "/"
	}, {
		label: "robots",
		link: "/browseCourse/robots",
	}, {
		label: "computer_it",
		link: "/browseCourse/computer_it"
	}, {
		label: "ai",
		link: "/browseCourse/ai"
	}, {
		label: "radio",
		link: "/browseCourse/radio"
	}, {
		label: "engineering",
		link: "/browseCourse/engineering"
	}, {
		label: "english",
		link: "/browseCourse/english",
	}, {
		label: "interest",
		link: "/browseCourse/interest"
	},
	{
		label: "product",
		link: "/product",
	}, 
	{
		label: "about",
		link: "/about"
	}, {
		label: "contact",
		link: "/contact"
	},
	{
		label: "pdf",
		link: "/pdf"
	},
	{
		label: "extra",
		link: "/extra"
	},
	
]

export { menuItems };